import _Symbol from "@babel/runtime-corejs2/core-js/symbol";

/**
 * Allowed colors of tag
 * @enum {String}
 */
export var Color = {
  LIGHT_STEEL_BLUE: 'light-steel-blue',
  PLUM: 'plum',
  MISTY_ROSE: 'misty-rose',
  LIGHT_GOLDENROD_YELLOW: 'light-goldenrod-yellow',
  PALE_GREEN: 'pale-green',
  SILVER: 'silver',
  GRAY: 'gray'
};
/**
 * @const
 * @type {String}
 */

export var COLORED_CLASS_NAME = 'wind-tag-colored';
/**
 * @const
 * @type {String}
 */

export var COLORED_GROUP_CLASS_NAME = "".concat(COLORED_CLASS_NAME, "-group");
/**
 * @const
 * @type {Symbol}
 */

export var PROTECTED_TYPE = _Symbol('TAG_PROTECTED_TYPE');